<template>
    <div class="c_table_wrap">
        <table>
            <colgroup>
                <col width="200px;">
                <col width="">
            </colgroup>
            <tr>
                <td class="c_t_title">푸시 제목</td>
                <td colspan="3">
                    <div>
                        <el-input v-model="title"></el-input>
                        <div class="input_error">{{ validation.firstError('title') }}</div>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">푸시 내용</td>
                <td colspan="3">
                    <div>
                        <el-input type="textarea" rows="4" resize="none" v-model="content"></el-input>
                        <div class="input_error">{{ validation.firstError('content') }}</div>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import pushValidator from "@/mixins/validators/PushValidator";
import util from "@/mixins/util";
import EventBus from "@/mixins/event-bus";
import alertMixins from "@/mixins/alertMixins";

export default {
    name: "pushComponent",
    mixins: [pushValidator, alertMixins],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            isRunning: false,
            parsingData: {title: 'title', content: 'content'},
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        EventBus.$on('sendPush', this.sendPush);
    },
    beforeDestroy() {
        EventBus.$off('sendPush');
    },
    destroyed() {
    },
    computed: {},
    methods: {
        initData() {
            this.title = '';
            this.content = '';
        },

        _checkValidator() {
            let validatorArr = Object.keys(this.parsingData);
            return this.$validate(validatorArr).then(success => {
                if (!success) {
                    this.errorAlert('필수데이터를 확인해주세요.')
                    return success
                }
                return success;
            })
        },

        _makeParams() {
            let params = {
                as_use: 1,
                as_send_type: 'instant',
                as_receiver_type: 'all',
                send_type: 'push',
            }
            util.Object.each(this.parsingData, (dataKey, paramKey, obj) => {
                params[paramKey] = this[dataKey];
            })
            return params;
        },

        async sendPush() {
            if (this.isRunning) {
                return false;
            }
            this.isRunning = true;
            let validator = await this._checkValidator();
            if (!validator) {
                this.isRunning = false;
                return false;
            }
            EventBus.$emit('changeLoading', true);
            let params = this._makeParams();

            try {
                this.isRunning = false;
                EventBus.$emit('changeLoading', false);
                this.$api.$push.sendPush(params).then(res => res.Data.Result).then(res => {
                    if (res.Info.Type < 1) {
                        this.createAlert({
                            title: '',
                            content: '알람이 전송 되었습니다.',
                            btnText: '확인',
                            hide: () => {
                                this.initData();
                            }
                        })
                        this.isRunning = false;
                        EventBus.$emit('changeLoading', false);
                    } else {
                        this.errorAlert(res.Info.reason);
                    }
                })
            } catch (e) {
                console.log(e)
                this.isRunning = false;
                EventBus.$emit('changeLoading', false);
            }
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
